// --------------------------------------------------------
// src/helpers/siemaPaginator.js
//
// This file works as a Siema extension. It adds a pagination
// feature to a Siema carousel object.
//
// --------------------------------------------------------
(function() {

	var handleSelector, indicatorSelector, observer;
	handleSelector = ".ui-bullet-handle";
	indicatorSelector = ".ui-indicator";

	/**
	 * Constructor
	 */
	var SiemaPaginator = function() {
		this.innerElements = null;
		this.currentPos = 0;

		// Default parameters
		var defaults = {
			parent: document.createElement("div"),
			selector: ".ui-indicator",
			paginator: null
		};

		if (arguments[0] && typeof arguments[0] === "object") {
    		this.options = extendDefaults(defaults, arguments[0]);
   		}

		// Initialize the object
		init.call(this);

		// Listen to the styling changes
		listen.call(this);
	};

	/**
	 * Initialize the object and place the bullets into its parent
	 *
	 * @return void
	 */
	function init() {
		// Reference to Siema
		let paginator = this.options.paginator,
			// The container for the bullets
			container = document.createElement("div"),
			// Self reference
			self = this,
			// The bullets
			div;
		// Append the container to its parent
		container.classList.add("bullets-container");
		this.options.parent.append(container);
		// Add a bullet for every slides in the carousel
		for (let i = 0; i < paginator.innerElements.length; i++) {
			div = document.createElement("div");
			div.classList.add(handleSelector.replace(".", ""));
			div.setAttribute("data-slide", i);
	 		container.appendChild(div);
		}
		// Create a final bullet that will be used to indicate the current slide
		div = document.createElement("div");
		div.classList.add(indicatorSelector.replace(".", ""));
		div.setAttribute("data-slide", 0);
		container.appendChild(div);

		// Bind an event listener to the bullets
		$(document).on("click", handleSelector, function(e){
		// Move the bullet indicator to the requested slide
			self.move($(e.target).data("slide"));
		});

		this.innerElements = container.children;
		if (paginator.currentSlide !== this.currentPos) {
			this.move(paginator.currentSlide);
		}
	}

	/**
	 * Move the indicator to a specified position
	 *
	 * @param slide
	 * @return void
	 */
	SiemaPaginator.prototype.move = function(slide) {
	    // The current slide
	    var currentSlide = $(indicatorSelector).attr("data-slide");
	    // The current direction of the indicator
	    var currentDirection = slide < currentSlide ? "right" : "left";
	    // The direction where the indicator will be moving toward
	    var newPos = slide > currentSlide ? "right" : "left";
	    // Move the carousel to the requested slide
	    this.options.paginator.goTo(slide);
	    // Update the indicator's attributes
	    this.currentPos = slide;
	    $(indicatorSelector).attr("data-slide", slide);
	    $(indicatorSelector).removeClass("move-" + currentDirection);
	    $(indicatorSelector).addClass("move-" + newPos);
	};

	/**
	 * Listen to attributes changes
	 *
	 * @return void
	 */
	function listen() {
		var self = this;

		if (document.querySelector(indicatorSelector) !== null) {
			observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					self.currentPos = mutation.target.dataset.slide;
				});
			});
			observer.observe(document.querySelector(indicatorSelector), { attributes: true });
		}
	}


	// Utility method to extend defaults with user options
	function extendDefaults(source, properties) {
  		var property;

  		for (property in properties) {
      		if (properties.hasOwnProperty(property)) {
      			source[property] = properties[property];
      		}
    	}
    	return source;
	}

	window.SiemaPaginator = SiemaPaginator;

}());
